import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './profile-tile.component.scss';
import { MediaQueryService } from '../../services/media-query.service';
import * as $ from 'jquery';
var ProfileTile = /** @class */ (function (_super) {
    tslib_1.__extends(ProfileTile, _super);
    function ProfileTile(element) {
        var _this = _super.call(this, element) || this;
        _this.autoHeight = 'true';
        return _this;
    }
    ProfileTile.prototype.init = function () {
        var _this = this;
        if (!this.element.classList.contains('profile-tile__stack')) {
            if (this.element.getAttribute('data-autoheight')) {
                this.autoHeight = this.element.getAttribute('data-autoheight').toString();
            }
            this.tabComponent = $(this.element);
            this.tabsContent = Array.from(this.tabComponent.find('.profile-tile-container__item-content'));
            setTimeout(function () {
                _this.equalHeights();
            }, 100);
            this.initTabs();
            this.slideRunner = this.tabComponent.find('.profile-tile-container__slide-runner');
            this.tabTriggers = Array.from(this.tabComponent.find('.js-tab-trigger'));
            this.activeTabTrigger = this.tabComponent.find('.profile-tile-container__item--active');
            this.activeTab = this.tabComponent.find('.profile-tile-container__item-content--active');
            this.dropdown = this.element.querySelector('.js-option-selector');
            this.slideRunner = this.tabComponent.find('.profile-tile-container__slide-runner');
            this.tabTriggers = Array.from(this.tabComponent.find('.js-tab-trigger'));
            this.activeTabTrigger = this.tabComponent.find('.profile-tile-container__item--active');
            this.activeTab = this.tabComponent.find('.profile-tile-container__item-content--active');
            $(document).ready(function () {
                _this.moveSlideRunner();
            });
        }
    };
    ProfileTile.prototype.bindEvents = function () {
        var _this = this;
        if (!this.element.classList.contains('profile-tile__stack')) {
            this.tabTriggers.map(function (item) { return item.addEventListener('click', function (event) {
                _this.toggleTabs(event);
                _this.moveSlideRunner();
            }); });
            window.addEventListener('resize', this.debounce(function () {
                _this.moveSlideRunner();
            }, 250, false));
            window.addEventListener('resize', this.onResize.bind(this));
            this.dropdown.addEventListener('change', function (event) {
                var element = event.target;
                var index = element.selectedIndex;
                var value = element.value;
                _this.dropdownSelection(value, index);
            });
        }
    };
    ProfileTile.prototype.onResize = function () {
        var _this = this;
        setTimeout(function () {
            _this.equalHeights();
        }, 100);
    };
    ProfileTile.prototype.initTabs = function () {
        var tabs = this.tabComponent.find('.profile-tile-container__item');
        var tabsContent = this.tabsContent;
        for (var i = 0; i < tabs.length; i++) {
            var tabGuid = this.generateGuid();
            $(tabs[i]).attr('data-target', "profile-tile-container__item-" + tabGuid);
            $(tabsContent[i]).attr('id', "profile-tile-container__item-" + tabGuid);
        }
    };
    ProfileTile.prototype.equalHeights = function () {
        if (this.autoHeight == 'true') {
            var elements = this.tabsContent;
            for (var i = 0; i < elements.length; i++) {
                if (!elements[i].classList.contains('profile-tile-container__item-content--active')) {
                    elements[i].style.height = '0';
                }
                else {
                    elements[i].style.height = 'auto';
                }
            }
            if (MediaQueryService.getMediaQuery() !== 'small' && MediaQueryService.getMediaQuery() !== 'x-small') {
                var tallestElement = 0;
                for (var i = 0; i < elements.length; i++) {
                    var el = elements[i];
                    if (el.classList.contains('profile-tile-container__item-content--active')) {
                        var elHeight = el.offsetHeight;
                        if (elHeight > tallestElement) {
                            tallestElement = elHeight;
                        }
                    }
                }
                for (var i = 0; i < elements.length; i++) {
                    elements[i].style.height = tallestElement + "px";
                    if (!elements[i].classList.contains('profile-tile-container__item-content--active')) {
                        elements[i].style.height = '0';
                    }
                }
            }
        }
    };
    ProfileTile.prototype.toggleTabs = function (event) {
        if (!$(event.currentTarget).hasClass('profile-tile-container__item--active')) {
            this.closeTab();
            this.activeTabTrigger = $(event.currentTarget);
            this.activeTab = this.tabComponent.find("#" + this.activeTabTrigger.attr('data-target'));
            this.openTab();
        }
        this.equalHeights();
    };
    ProfileTile.prototype.moveSlideRunner = function () {
        var tabPositionLeft = this.activeTabTrigger.position().left;
        var tabWidth = this.activeTabTrigger.width();
        this.slideRunner
            .width(0)
            .css('left', tabPositionLeft + "px")
            .show()
            .delay(350)
            .width(tabWidth);
    };
    ProfileTile.prototype.generateGuid = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    ProfileTile.prototype.closeTab = function () {
        this.activeTabTrigger.removeClass('profile-tile-container__item--active');
        this.activeTab.removeClass('profile-tile-container__item-content--active');
    };
    ProfileTile.prototype.openTab = function () {
        this.activeTabTrigger.addClass('profile-tile-container__item--active');
        this.activeTab.addClass('profile-tile-container__item-content--active');
    };
    ProfileTile.prototype.debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate)
                    func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow)
                func.apply(context, args);
        };
    };
    ProfileTile.prototype.dropdownSelection = function (value, index) {
        if (index == 0) {
            index = 4;
        }
        if (index && value) {
            if (index == 4) {
                index = 0;
            }
            this.tabsContent.map(function (item, indexContent) {
                item.classList.remove('profile-tile-container__item-content--active');
                item.style.height = '0';
                if (indexContent === index) {
                    item.classList.add('profile-tile-container__item-content--active');
                    item.style.height = 'auto';
                }
            });
            this.tabTriggers.map(function (item, indexTabItem) {
                item.classList.remove('profile-tile-container__item--active');
                if (indexTabItem === index) {
                    item.classList.add('profile-tile-container__item--active');
                }
            });
        }
    };
    return ProfileTile;
}(Base));
export { ProfileTile };



//////////////////
// WEBPACK FOOTER
// ./components/profile-tile/profile-tile.component.ts
// module id = 467
// module chunks = 0